import React from "react";
import { FaStar } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { FaRegCommentDots } from "react-icons/fa";
import RankingIcon from "../ranking/ranking";
import StarRating from "../star-rating/star-rating";
import { userRankText } from "../../utils";

const ProductReviewSection = ({ product, productSlug, navigate }) => {
  return (
    <section className="pdp-reviews-card">
      <div className="pdp-reviews-head">
        <div>
          <h2 className="pdp-reviews-title">Đánh giá từ khách hàng</h2>
          <div className="pdp-reviews-score-chip">
            <p className="pdp-reviews-score">{product?.averageRating?.toFixed(1) || 0}</p>
            <FaStar className="pdp-reviews-score-icon" />
          </div>
        </div>

        <button
          onClick={() => navigate(`/product/reviews/${productSlug}`)}
          className="pdp-link-btn"
        >
          Xem tất cả <IoIosArrowForward />
        </button>
      </div>

      {Array.isArray(product?.reviews) && product?.reviews.length > 0 ? (
        <div className="pdp-review-grid">
          {product?.reviews.map((review) => (
            <ReviewItem key={review?._id} review={review} />
          ))}
        </div>
      ) : (
        <div className="pdp-empty-review">
          <div className="pdp-empty-review-icon-wrap">
            <FaRegCommentDots className="pdp-empty-review-icon" />
          </div>
          <p className="pdp-empty-review-text">Chưa có đánh giá nào</p>
          <p className="pdp-empty-review-subtext">Hãy là người đầu tiên để lại đánh giá cho sản phẩm này.</p>
        </div>
      )}
    </section>
  );
};

const ReviewItem = ({ review }) => {
  return (
    <article className="pdp-review-item">
      <img
        className="pdp-review-avatar"
        src={review?.userId?.profileImg || "https://i.pravatar.cc/300"}
        alt="user-avatar"
      />

      <div className="pdp-review-content">
        <div className="pdp-review-top">
          <p className="pdp-review-user">{review?.userId?.username || "Người dùng"}</p>
          <StarRating rating={review?.rating || 0} />
        </div>

        <div className="pdp-review-rank">
          <RankingIcon rank={review?.userId?.rank || "diamond"} />
          <p className="pdp-review-rank-text">{userRankText(review?.userId?.rank) || ""}</p>
        </div>

        <div className="pdp-review-bottom">
          <p className="pdp-review-comment">{review?.comment}</p>
          <p className="pdp-review-date">{new Date(review?.createdAt).toLocaleDateString() || ""}</p>
        </div>
      </div>
    </article>
  );
};

export default ProductReviewSection;
